import * as React from 'react'
import { Menu, Row, Col, Spin, message } from 'antd'
import { inject, observer } from 'mobx-react'
import { ComponentExt } from 'util/reactExt'
import styles from './index.scss'
import {
  checkStatus,
  taskCompletedStatus,
  taskStatus,
  taskType,
} from 'constants/index'
// import { withPopover } from 'components/HOC/AntdWrapper'
import TestListModal from 'containers/views/Levelup/TestListModal'
import VPlayer from 'components/VPlayer'
import { TVType } from 'components/VideoPanel'
import {
  types as VideoTypes,
  isSelfVideo,
  sohufilter,
} from 'components/VideoPanel'
import { randomColor, addEvent } from 'util/utils'

import examIcon from 'assets/check/exam-task.png'
import videoIcon from 'assets/check/video-task.png'
import textIcon from 'assets/check/text-task.png'
import completedSvg from 'assets/check/done-task.svg'
import timeoutActiveIcon from 'assets/timeout-active-icon.svg'
import undoSvg from 'assets/undo.svg'

const PER_PAGE = 100
const MenuItem = Menu.Item

const videoTypeIconMap = {
  [taskType.video]: videoIcon,
  [taskType.example]: examIcon,
  [taskType.exam]: examIcon,
  [taskType.text]: textIcon,
}

const videoIconMap = {
  completed: completedSvg,
  expired: timeoutActiveIcon,
  undo: undoSvg,
}

interface IVideoCheckProps {
  check: any
  testRef?: any
  timer?: any
  levelStore?: any
  toggleAudioVoice: (config?: any) => void
  setCurrentTaskIndex: (val: number) => void
  onCloseCheckPanelModal: () => void
  onOpenPassCheckModal: () => void
}

interface IVideoCheckState {
  videoUrl: string
  currentTask: any
  testData: any
  btnClicked: boolean
  video: any
  info: any
  currentTaskIndex: number
  finishProgress: string
}

@inject('globalStore', 'levelStore')
@observer
export default class VideoCheck extends ComponentExt<
  IVideoCheckProps,
  IVideoCheckState
> {
  state = {
    videoUrl: '',
    currentTask: null,
    testData: null,
    btnClicked: false,
    video: null,
    info: null,
    currentTaskIndex: -1,
    finishProgress: '',
  }

  private timer
  private testRef
  private audioNode = document.getElementById('audio')

  async componentDidMount() {
    const {
      check: { check_task_records },
    } = this.props
    let doingTaskIndex = check_task_records.findIndex(
      task => task.status === taskStatus.doing,
    )
    doingTaskIndex = doingTaskIndex < 0 ? 0 : doingTaskIndex
    const {
      check_task: { type },
    } = check_task_records[doingTaskIndex]

    await this.gotoTask(
      type,
      check_task_records[doingTaskIndex],
      doingTaskIndex,
    )

    this.setState({
      currentTask: check_task_records[doingTaskIndex],
    })
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
  }

  bindAudioEvent = (type: 'bind:play' | 'bind:error') => {
    const { info } = this.state
    if (type === 'bind:play') {
      addEvent(this.audioNode, 'play', () => this.onPlay())
    } else if (type === 'bind:error') {
      addEvent(this.audioNode, 'error', () => {
        if (typeof info.content !== 'undefined') {
          message.error('该播放源可能已损坏，请联系管理员')
        }
      })
    }
  }

  onPlay = () => {
    const {
      levelStore: { toggleAudioVoice },
    } = this.props
    toggleAudioVoice(
      {
        src: '',
      },
      'bg',
    )
    this.studying()
  }

  studying = () => {
    clearTimeout(this.timer)
    this.timer = setTimeout(async () => {
      const { id, random } = this.state.info

      this.api.article.statistics(id, random)
      this.studying()
    }, 60000)
  }

  onRef = ref => {
    this.testRef = ref
  }

  get videoType() {
    const { video } = this.state
    return video
      ? (VideoTypes.filter(v => v.key === video.type)[0].value as TVType)
      : ''
  }

  //  视频
  renderVideoComponent = () => {
    const {
      currentTask,
      currentTask: {
        check_task: { name },
        status,
      },
      info,
      video,
    } = this.state
    // @ts-ignore
    if (this.videoType === 'article') {
      return (
        <div className={styles.videoArticle}>
          {/^\/\//.test(info.content) ? (
            <Spin />
          ) : (
            <div>
              <h3>{info.title}</h3>
              <div
                dangerouslySetInnerHTML={{ __html: info.content }}
                style={{ height: 420, overflow: 'scroll', textAlign: 'left' }}
              />
              <section className={styles.taskBtn}>
                {/*tslint:disable*/
                info.course_time != 0 && (
                  <span
                    className={styles.taskRequriedTime}
                  >{`文章阅读时长为 ${info.course_time} 分钟`}</span>
                )}
                <a
                  className={`${styles.btn} ${
                    status === taskStatus.done ? styles.disabled : ''
                  }`}
                  onClick={() => {
                    this.getStatusOfTask(currentTask)
                    this.onPlay()
                  }}
                  onMouseDown={this.switchBtnEffect.bind(this, '+')}
                  onMouseUp={this.switchBtnEffect.bind(this, '-')}
                >
                  {'我已阅读'}
                </a>
              </section>
            </div>
          )}
        </div>
      )
    } else if (this.videoType === 'audio') {
      // @ts-ignore
      return (
        <div className={styles.videoAudio}>
          <h3>{info.title}</h3>
          <audio
            id="audio"
            src={info.content}
            className="plyr"
            autoPlay={false}
            preload="meta"
            controls
            controlsList="nodownload"
          />
          <div style={{ textAlign: 'center', marginTop: 10 }}>
            <a
              className={`${styles.btn} ${
                status === taskStatus.done ? styles.disabled : ''
              }`}
              onClick={() => this.getStatusOfTask(currentTask)}
              onMouseDown={this.switchBtnEffect.bind(this, '+')}
              onMouseUp={this.switchBtnEffect.bind(this, '-')}
            >
              {'我已收听'}
            </a>
          </div>
        </div>
      )
    }

    return (
      <div className={`${styles.task} ${'styles.videoTask'}`}>
        <h2 className={styles.taskTitle}>{name}</h2>
        <section className={styles.taskContent}>
          {isSelfVideo(info.content) ? (
            <VPlayer
              type={this.videoType}
              src={info.content}
              onplay={this.onPlay}
            />
          ) : (
            sohufilter(info.content)
          )}
        </section>
        <section className={styles.taskBtn}>
          <a
            className={`${styles.btn} ${
              status === taskStatus.done ? styles.disabled : ''
            }`}
            onClick={this.getStatusOfTask.bind(this, currentTask)}
            onMouseDown={this.switchBtnEffect.bind(this, '+')}
            onMouseUp={this.switchBtnEffect.bind(this, '-')}
          >
            {'我已观看'}
          </a>
        </section>
      </div>
    )
  }

  renderExampleComponent = () => {
    const {
      testData,
      currentTask: { status },
    } = this.state
    const isTaskDone = status === taskStatus.done

    return (
      <div className={`${styles.task} ${'styles.exampleTask'}`}>
        <h2 className={`${styles.taskTitle} ${styles.exampleTitle}`}>
          练习题 {this.state.finishProgress}
        </h2>
        <section className={styles.taskContent}>
          {testData && (
            <TestListModal
              data={testData}
              onRef={this.onRef}
              onProgressChanged={this.onProgressChanged}
            />
          )}
        </section>
        <section className={styles.taskBtn}>
          <a
            className={`${styles.btn} ${!isTaskDone ? styles.coverBtn : ''} ${
              isTaskDone ? styles.disabled : ''
            }`}
            onClick={this.submitExam}
            onMouseDown={this.switchBtnEffect.bind(this, '+')}
            onMouseUp={this.switchBtnEffect.bind(this, '-')}
          >
            {'我已完成'}
          </a>
        </section>
      </div>
    )
  }

  onProgressChanged = val => {
    this.setState({
      finishProgress: val,
    })
  }

  submitExam = async (): Promise<any> => {
    if (this.testRef.completeTest) {
      await this.getStatusOfTask(this.state.currentTask)
    } else {
      return
    }
  }

  switchBtnEffect = (mode: string) => {
    this.setState({
      btnClicked: mode === '+' ? true : false,
    })
  }

  showResultModal = () => {
    const { onCloseCheckPanelModal, onOpenPassCheckModal } = this.props

    setTimeout(() => {
      onCloseCheckPanelModal()
      onOpenPassCheckModal()
    }, 1000)
  }

  renderTextComponent = () => {
    const {
      currentTask,
      currentTask: {
        check_task: { name },
        status,
      },
    } = this.state
    const isTaskDone = status === taskStatus.done

    return (
      <div className={`${styles.task} ${'styles.textTask'}`}>
        <div className={`${styles.task} ${'styles.exampleTask'}`}>
          <section className={styles.taskContent}>
            <p
              dangerouslySetInnerHTML={{
                __html: name,
              }}
            />
          </section>
          <section className={styles.taskBtn}>
            <a
              className={`${styles.btn} ${!isTaskDone ? styles.coverBtn : ''} ${
                isTaskDone ? styles.disabled : ''
              }`}
              onClick={this.getStatusOfTask.bind(this, currentTask)}
              onMouseDown={this.switchBtnEffect.bind(this, '+')}
              onMouseUp={this.switchBtnEffect.bind(this, '-')}
            >
              {'我已阅读'}
            </a>
          </section>
        </div>
      </div>
    )
  }

  renderTaskList = (task, index) => {
    const {
      check: { overtime },
    } = this.props
    const taskName =
      task.check_task.type === taskType.video ||
      task.check_task.type === taskType.text
        ? task.check_task.name
        : '复习与总结'
    const taskComponent = (
      <a
        onClick={this.gotoTask.bind(this, task.check_task.type, task, index)}
        className={styles.ellipsis}
      >
        {taskName}
      </a>
    )

    return (
      <MenuItem
        disabled={
          task.status === taskStatus.unfinished ||
          task.status === taskStatus.todo
        }
        key={task.id}
        className={styles.listItem}
      >
        <span
          className={styles.leftIcon}
          style={{
            position: 'relative',
            backgroundImage: `url(${videoTypeIconMap[task.check_task.type]})`,
          }}
        />
        {taskComponent}
        <span
          className={styles.rightIcon}
          style={{
            position: 'relative',
            backgroundImage: `url(${
              videoIconMap[taskCompletedStatus.overtime[overtime][task.status]]
            })`,
          }}
        />
      </MenuItem>
    )
  }

  gotoTask = async (type, task, index?): Promise<any> => {
    if (type === taskType.video) {
      const {
        check_task: { video },
      } = await this.api.level.getCheckTaskRecordDetail(task.id)

      this.setState({
        video,
        currentTaskIndex: index,
      })

      await this.getArticleDetail(video.article_id)
      // 任务类型为视频文章
      if (this.state.info.type === VideoTypes[1].key) {
        this.onPlay()
      }
    } else if (type !== taskType.text) {
      await this.fetchTestData(task.id)
    }

    this.setState({
      currentTask: task,
      currentTaskIndex: index,
    })
    this.props.setCurrentTaskIndex(index)

    if (this.videoType === 'audio') {
      this.audioNode = document.getElementById('audio')
      this.bindAudioEvent('bind:play')
      this.bindAudioEvent('bind:error')
    }
  }

  getArticleDetail = async (id): Promise<any> => {
    try {
      const { data, status } = await this.api.article.getArticleDetail(id)
      if (status === 500) {
        this.$message.error('您没有权限访问该视频，窗口3秒后关闭')
        setTimeout(() => {
          window.close()
        }, 3000)
        return
      }
      const nstate: any = {
        info: data,
        note: data.user_note ? data.user_note.content : '',
        colors: randomColor((data.labels && data.labels.length) || 0),
        collect: {
          collectCount: data.collect.collect_count,
          hasCollect: data.collect.has_collect,
        },
      }
      this.setState(nstate)
    } catch (err) {
      console.error(err)
    }
  }

  fetchTestData = async id => {
    const testData = await this.api.level.getCheckTaskRecordDetail(id)
    this.setState({
      testData,
    })
  }

  getStatusOfTask = async (task: any): Promise<any> => {
    const {
      check: { grade },
      levelStore: {
        getCheckTaskRecord,
        getUserCheckRecord,
        setCurrentUserCheck,
        fetchCheckTaskRecords,
        currentUserCheck,
      },
    } = this.props
    const { currentTask, info } = this.state
    /* tslint:disable */
    const self = this
    const responseStatus = await getCheckTaskRecord(task.id, grade - 1)
    if (task.status === taskStatus.done) {
      return this.$message.success('当前任务已完成。')
    }
    if (responseStatus === taskStatus.doing) {
      const unfinishedText =
        info.type === VideoTypes[1].key && info.course_time != 0
          ? `当前文章阅读时间为 ${info.course_time} 分钟。`
          : '您尚未完成当前任务。'
      this.$message.info(unfinishedText)
    } else if (responseStatus === taskStatus.discard) {
      this.$message.info('操作无效，管理员已更新当前通关进度，请刷新网页。')
    } else if (responseStatus === taskStatus.done) {
      this.$message.success('当前任务已完成。')

      fetchCheckTaskRecords(currentUserCheck.id).then(data => {
        const {
          levelStore: {
            userCheckRecord: {},
          },
        } = self.props
        setCurrentUserCheck(data)

        if (data.status === checkStatus.done) {
          this.showResultModal()
          return
        }

        const doingTaskIndex = data.check_task_records.findIndex(
          task => task.status === taskStatus.doing,
        )

        if (doingTaskIndex >= 0) {
          const {
            check_task: { type },
          } = data.check_task_records[doingTaskIndex]

          this.gotoTask(
            type,
            data.check_task_records[doingTaskIndex],
            doingTaskIndex,
          )
        }
      })
    } else {
      this.$message.info(`当前任务状态为：${responseStatus}。`)
    }
  }

  render() {
    const {
      check: { check_task_records },
    } = this.props
    const taskComponent = {
      [taskType.video]: this.renderVideoComponent,
      [taskType.example]: this.renderExampleComponent,
      [taskType.text]: this.renderTextComponent,
    }
    const { currentTask } = this.state
    const type =
      currentTask && currentTask.check_task && currentTask.check_task.type

    return (
      <div className={styles.videoCheck}>
        <section className={styles.leftContent}>
          <Menu
            defaultSelectedKeys={[currentTask && currentTask.id.toString()]}
            selectedKeys={[currentTask && currentTask.id.toString()]}
          >
            {check_task_records.map((task, index) =>
              this.renderTaskList(task, index),
            )}
          </Menu>
        </section>
        <section
          className={styles.rightContent}
          key={currentTask && currentTask.id}
        >
          {type && taskComponent[type]()}
        </section>
      </div>
    )
  }
}
